/**
 * TimeRuler Component
 * 
 * Top ruler showing time markers with zoom controls.
 */

import React from 'react';
import { formatTime } from '../../utils/scheduler';
import '../../styles/menuPlanning.css';

interface TimeRulerProps {
  makespanSec: number;
  pixelsPerSecond: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
}

export const TimeRuler: React.FC<TimeRulerProps> = ({
  makespanSec,
  pixelsPerSecond,
  onZoomIn,
  onZoomOut,
  canZoomIn,
  canZoomOut
}) => {
  // Generate time markers every 15 minutes
  const markerIntervalSec = 15 * 60;
  const markers: number[] = [];
  
  for (let t = 0; t <= makespanSec; t += markerIntervalSec) {
    markers.push(t);
  }
  
  // Add final marker if not already included
  if (markers.length === 0 || markers[markers.length - 1] < makespanSec) {
    markers.push(makespanSec);
  }

  return (
    <div className="time-ruler">
      <div className="time-ruler-markers">
        {markers.map((timeSec) => (
          <div
            key={timeSec}
            className="time-ruler-marker"
            style={{ minWidth: '60px' }}
          >
            {formatTime(timeSec)}
          </div>
        ))}
      </div>
      <div className="time-ruler-controls">
        <span style={{ fontSize: '11px', marginRight: '8px' }}>
          Total: {formatTime(makespanSec)}
        </span>
        <button
          className="time-ruler-button"
          onClick={onZoomOut}
          disabled={!canZoomOut}
          title="Zoom out"
        >
          −
        </button>
        <button
          className="time-ruler-button"
          onClick={onZoomIn}
          disabled={!canZoomIn}
          title="Zoom in"
        >
          +
        </button>
      </div>
    </div>
  );
};

export default TimeRuler;


